export enum LabelTypeMetadata {
  BackOfPack = 0,
  FrontOfPack = 1
}